// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"4aae8b2e","453":"42ee20e1"}[chunkId] + ".chunk.js";
};